
<template>
  <div>
    <div
      v-if="
        message.text &&
        (message.type === 'human' || message.type === 'feedback')
      "
      class="message-text"
      id="map_container"
      :style="{
        color: message.type === 'bot' ? '' : '#fff',
        padding: this.message.alts !== null ? '1em ' : '',
        'font-size': '4vw',
        'padding-right': '0em',
      }"
    >
      <!-- <magnifier :url="storageUrl" :scale="5"></magnifier> -->
      <!-- <img src="https://renpho-cloud.s3.amazonaws.com/renpho-lex/scale-FAQ/2.png" width="100" height="200"> -->
      <span class="sr-only">I say: </span>{{ message.text }}
    </div>
    <!-- v-lazy-container="{ selector: 'img' }" -->

    <div
      v-scroll
      v-lazy="{ selector: 'img' }"
      v-else-if="altHtmlMessage && AllowSuperDangerousHTMLInMessage"
      v-html="altHtmlMessage"
      class="message-text"
      ref="messageT"
      :style="{
        padding: '0.5em',
        'margin-left': message.responseCard ? '-10vw' : '',
        width: message.responseCard ? '105vw' : '',
        fontSize: message.responseCard ? '4.5vw' : '',
        'font-weight': !message.responseCard
          ? ''
          : this.$i18n.locale === 'tc' || 'zh' || 'ja'
          ? '900'
          : '',
      }"
    ></div>
    <!-- <van-image-preview
      v-if="showPic"
      v-model="showPic"
      :images="imagesTest"
      :show-index="false"
      :closeable="true"
      @closed="handleClose"
    >
    </van-image-preview>   -->

    <div v-else-if="message.text && shouldRenderAsHtml">
      <div
        d-flex
        v-html="botMessageAsHtml"
        class="message-text"
        :style="{
          marginTop: message.id === 2 ? '-18vw' : '',
          display:
            message.text === 'Sorry' ||
            message.text === 'Aww' ||
            message.text === '啊哇' ||
            this.message.text === 'ああ' ||
            this.message.text === '噢'
              ? 'none'
              : '',

          fontSize: message.responseCard ? '' : '',

          'padding-right': '0.5em',
        }"
      ></div>
      <!--indicator-color="red" :touchable="touchable" @touchstart="onTouchStart"
          @touchmove="onTouchMove" -->
      <!--   v-show="language === 'en'" :class="{ buton: index === dynamic }"       :style="{display: index === 7  &&  language=== 'tc' ? 'none' :'normal'}"  -->
      <!-- display: index === 7  ? 'none' :'normal' -->
      <!-- <van-swipe
        @change="onChange"
        :loop="false"
        lazy-render
        :width="clientWidth"
        v-if="message.id === 2"
        class="my-swipe2"
      >    
        <van-swipe-item
       
          id="item0"
          :style="{
            marginRight: '3vw',
            width: clientWidth - '160vw',
            'padding-bottom': '2vw',
          }"
        >
          <div v-if="message.id === 2">
            <div
              :style="{
                width: '86vw',
              }"
            >
              <ul
                v-for="(item, index) in initalMsg"
                :key="index"
                v-on:click="Faq(item)"
                class="initalMsgbtn"
              >
              
                <li
                  :style="{
                    'font-size': '4vw',
                    marginLeft: '6vw',
                    color: '#55bee5',
                  }"
                >
                  <div class="question">
                  
                    {{ item }}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </van-swipe-item>
        <van-swipe-item
          :style="{ width: '85vw' }"
          id="item1"
        >
          <div
            :style="{
              width: '86vw',
            }"
          >
            <ul
              v-for="(item, index) in initalMsg2"
              :key="index"
              v-on:click="Faq(item)"
              class="initalMsgbtn"
            >
              <li
                :style="{
                  'font-size': '4vw',
                  marginLeft: '6vw',
                  color: '#55bee5',
                }"
              >
                <div class="question">
                  {{ item }}
                </div>
              </li>
            </ul>
          </div>
        </van-swipe-item>
        <template #indicator>
          <ul class="indicators indicator">
            <div v-if="current === 0">
              <li class="indicatorli"></li>
              <li class="indicatorli2"></li>
            </div>
            <div v-else-if="current === 1">
              <li class="indicatorli3"></li>
              <li class="indicatorli4"></li>
            </div>
          </ul>
        </template>
      
      </van-swipe>  -->
      <swiper
        class="my-swipe2"
        v-if="message.id === 2"
        :options="swiperOption"
        ref="mySwiper"
      >
        <swiper-slide class="my-swipe3">
          <!-- <div > -->
          <div v-if="message.id === 2">
            <ul
              v-for="(item, index) in initalMsg"
              :key="index"
              v-on:click="Faq(item)"
              class="initalMsgbtn"
            >
              <li
                :style="{
                  'font-size': '6vw',
                  marginLeft: '8vw',
                  color: '#55bee5',
                }"
              >
                <div class="question">
                  {{ item }}
                </div>
              </li>
            </ul>

            <!-- </div> -->
          </div>
        </swiper-slide>
        <swiper-slide class="my-swipe4">
          <ul
            v-for="(item, index) in initalMsg2"
            :key="index"
            v-on:click="Faq(item)"
            class="initalMsgbtn"
          >
            <li
              :style="{
                'font-size': '6vw',
                marginLeft: '8vw',
                color: '#55bee5',
              }"
            >
              <div class="question">
                {{ item }}
              </div>
            </li>
          </ul>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <!-- <template #indicator >
                <ul class="indicators indicator">
                  <li
                      v-for="(item, index) in list" :key="index"
                      :class="{active: checkActive(index)}"
                  ></li>
                </ul>
            </template> -->
      <!-- <van-swipe v-if="message.id === 0" :loop="false"  class="my-swipe"  indicator-color="white">
  <van-swipe-item :style="{'background-color': 'red'}">1</van-swipe-item>
  <van-swipe-item>2  -->

      <!-- </van-swipe-item>
</van-swipe>  -->
      <!-- <div class="viewer-btn" style="display: none">
       <a href="javascript:" id="zoom_in"><i class="fa fa-search-plus">&nbsp;放大</i></a>
    </div> -->

      <div v-show="message.text.length > 110" v-on:click="changeFoldState">
        <!-- <SimpleGallery galleryID="pic" :images="images" /> -->

        <a
          style="
            display: flex;
            flex-direction: row;
            justify-content: center;
            color: #0a79c3;
            font-size: 1rem;
          "
          >{{
            brandFold
              ? $t("licence.Robot_massege_ViewMore")
              : $t("licence.Robot_massege_ViewLess")
          }}
          <img
            :src="require('../assets/up@2x.png')"
            width="22"
            height="22"
            style="margintop: -0.8vw"
            :style="{ transform: brandFold ? 'rotate(-180deg)' : '' }"
          />
        </a>

        <div style="width: 300px"></div>
      </div>
    </div>

    <div
      v-else-if="
        message.text && (message.type === 'bot' || message.type === 'agent')
      "
      class="bot-message"
    >
      <span class="sr-only">{{ message.type }} says: </span>

      {{ shouldStripTags ? stripTagsFromMessage(message.text) : message.text }}
    </div>
  </div>
</template>

  <script src="https://unpkg.com/jquery@3/dist/jquery.slim.min.js" crossorigin="anonymous"></script>
  <script src="https://unpkg.com/bootstrap@4/dist/js/bootstrap.bundle.min.js" crossorigin="anonymous"></script>
<script>
/*
Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Amazon Software License (the "License"). You may not use this file
except in compliance with the License. A copy of the License is located at

http://aws.amazon.com/asl/

or in the "license" file accompanying this file. This file is distributed on an "AS IS"
BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. See the
License for the specific language governing permissions and limitations under the License.
*/
import { ImagePreview } from "vant";
import Viewer from "viewerjs";
import { Pagination } from "swiper";
import axios from "axios";
import SimpleGallery from "./SimpleGallery.vue";
const marked = require("marked");
const renderer = {};
renderer.link = function link(href, title, text) {
  return `<a href="${href}" title="${title}" target="_blank">${text}</a>`;
};
marked.use({ renderer });

export default {
  name: "message-text",
  props: ["message"],
  data() {
    return {
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        }, // 下按钮

        //paginationClickable: true, //下面按钮让点吗
        direction: "horizontal",
        spaceBetween: 10,
        // loop: true,
        slidesPerView: 1.2,
        centeredSlides: true,
      },
      clientWidth: document.documentElement.clientWidth * 1.35,
      startX: null,
      touchable: true,
      list: [0, 1, 2],
      current: 0,
      modules: [Pagination],
      images: [
        {
          largeURL:
            "https://cdn.photoswipe.com/photoswipe-demo-images/photos/1/img-200.jpg",
          thumbnailURL:
            "https://cdn.photoswipe.com/photoswipe-demo-images/photos/1/img-200.jpg",
          width: 1875,
          height: 2500,
        },
        {
          largeURL:
            "https://cdn.photoswipe.com/photoswipe-demo-images/photos/2/img-2500.jpg",
          thumbnailURL:
            "https://cdn.photoswipe.com/photoswipe-demo-images/photos/2/img-200.jpg",
          width: 1669,
          height: 2500,
        },
        // {
        //   largeURL:
        //     'https://cdn.photoswipe.com/photoswipe-demo-images/photos/3/img-2500.jpg',
        //   thumbnailURL:
        //     'https://cdn.photoswipe.com/photoswipe-demo-images/photos/3/img-200.jpg',
        //   width: 2500,
        //   height: 1666,
        // },
      ],
      imagesTest: [
        "https://renpho-cloud.s3.amazonaws.com/renpho-lex/image/Readings+displayed+incompletely4.jpeg",
        "https://renpho-cloud.s3.amazonaws.com/renpho-lex/image/OperationThirdApple1.png",
      ],
      showPic: false,
      storageUrl:
        "https://renpho-cloud.s3.amazonaws.com/renpho-lex/Scale-FAQ/test1.JPG",
      isiOS: false,
      onLine: true,
      language: "",
      from: "",
      brandFold: true,
      dynamic: -1,
      listHeight: null,
      titleId: 0,
      dataImg: "",
      initalMsg: [],
      initalMsg2: [],
      pictureUrl: null,
      initalMsg_home: [
        // this.$t('licence.Robot_problem_solved'),
        this.$t("licence.Robot_greetings_label1"),
        this.$t("licence.Robot_greetings_label2"),
        this.$t("licence.Robot_greetings_label5"),
        this.$t("licence.Robot_greetings_label4"),
        this.$t("licence.Robot_greetings_label3"),
      ],
      initalMsg_home2: [
        this.$t("licence.Robot_greetings_label6"),
        this.$t("licence.Robot_greetings_label7"),
        this.$t("licence.Robot_greetings_label8"),
        this.$t("licence.Robot_greetings_label9"),
      ],
      initalMsg_login: [
        this.$t("licence.Robot_greetings_label1_login"),
        this.$t("licence.Robot_greetings_label2_login"),
        this.$t("licence.Robot_greetings_label3_login"),
        this.$t("licence.Robot_greetings_label4_login"),
        this.$t("licence.Robot_greetings_label5_login"),
      ],
      initalMsg_login2: [
        this.$t("licence.Robot_greetings_label6_login"),
        this.$t("licence.Robot_greetings_label7_login"),
        this.$t("licence.Robot_greetings_label8_login"),
        this.$t("licence.Robot_greetings_label9_login"),
      ],
      initalMsg_devicePage: [
        this.$t("licence.Robot_greetings_label1_devicePage"),
        this.$t("licence.Robot_greetings_label2_devicePage"),
        this.$t("licence.Robot_greetings_label3_devicePage"),
        this.$t("licence.Robot_greetings_label4_devicePage"),
      ],
      initalMsg_devicePage2: [
        this.$t("licence.Robot_greetings_label5_devicePage"),
        this.$t("licence.Robot_greetings_label6_devicePage"),
        this.$t("licence.Robot_greetings_label7_devicePage"),
        this.$t("licence.Robot_greetings_label8_devicePage"),
      ],
      initalMsg_mePage: [
        this.$t("licence.Robot_greetings_label1_mePage"),
        this.$t("licence.Robot_greetings_label2_mePage"),
        this.$t("licence.Robot_greetings_label3_mePage"),
        this.$t("licence.Robot_greetings_label4_mePage"),
        this.$t("licence.Robot_greetings_label5_mePage"),
      ],
      initalMsg_mePage2: [
        this.$t("licence.Robot_greetings_label6_mePage"),
        this.$t("licence.Robot_greetings_label7_mePage"),
        this.$t("licence.Robot_greetings_label8_mePage"),
        this.$t("licence.Robot_greetings_label9_mePage"),
      ],
      initalMsg_balancePage: [
        this.$t("licence.Robot_greetings_label1_balancePage"),
        this.$t("licence.Robot_greetings_label2_balancePage"),
        this.$t("licence.Robot_greetings_label3_balancePage"),
        this.$t("licence.Robot_greetings_label4_balancePage"),
        this.$t("licence.Robot_greetings_label5_balancePage"),
      ],
      initalMsg_balancePage2: [
        this.$t("licence.Robot_greetings_label6_balancePage"),
        this.$t("licence.Robot_greetings_label7_balancePage"),
        this.$t("licence.Robot_greetings_label8_balancePage"),
        this.$t("licence.Robot_greetings_label9_balancePage"),
      ],
      initalMsg_tapPage: [
        this.$t("licence.Robot_greetings_label1_tapPage"),
        this.$t("licence.Robot_greetings_label2_tapPage"),
        this.$t("licence.Robot_greetings_label3_tapPage"),
        this.$t("licence.Robot_greetings_label4_tapPage"),
      ],
      initalMsg_tapPage2: [
        this.$t("licence.Robot_greetings_label5_tapPage"),
        this.$t("licence.Robot_greetings_label6_tapPage"),
        this.$t("licence.Robot_greetings_label7_tapPage"),
      ],
    };
  },
  components: {
    SimpleGallery,
    // Swiper,
    //   SwiperSlide
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    shouldConvertUrlToLinks() {
      return this.$store.state.config.ui.convertUrlToLinksInBotMessages;
    },
    shouldStripTags() {
      return this.$store.state.config.ui.stripTagsFromBotMessages;
    },
    AllowSuperDangerousHTMLInMessage() {
      return this.$store.state.config.ui.AllowSuperDangerousHTMLInMessage;
    },
    altHtmlMessage() {
      // console.log('alt---',this.$refs.messageT.offsetHeight)
      let out = false;
      if (this.message.alts) {
        if (this.message.alts.html) {
          out = this.message.alts.html;
        } else if (this.message.alts.markdown) {
          console.log("finalout---", out, this.message.text);
          out = marked.parse(this.message.alts.markdown);
          console.log(
            "parseout---",
            this.message.alts.markdown,
            this.message.alts.markdown.length
          );
        }
      }

      if (out) out = this.prependBotScreenReader(out);
      // let test =  this.message.text
      //  if(!out && this.brandFold === false ){
      //   this.message.text = test
      // }else if (!out && this.brandFold === true && this.message.text.length > 100) {
      //  test.slice(0, 100) + "...";
      // }

      return out;
    },
    shouldRenderAsHtml() {
      return (
        ["bot", "agent"].includes(this.message.type) &&
        this.shouldConvertUrlToLinks
      );
    },
    botMessageAsHtml() {
      // Security Note: Make sure that the content is escaped according
      // to context (e.g. URL, HTML). This is rendered as HTML

      const messageText = this.stripTagsFromMessage(this.message.text);
      const messageWithLinks = this.botMessageWithLinks(messageText);

      console.log("botMessageAsHtml----", this.message.text);
      const messageWithSR = this.prependBotScreenReader(messageWithLinks);

      return messageWithSR;
    },
  },
  directives: {
    scroll: {
      inserted(el) {
        console.log("el---", el);
        el.scrollIntoView();
      },
    },

    lazy: {
      inserted(el, bing) {
        // console.log('图片懒加载')
        // new IntersectionObserver 创建我们的交叉观察器
        let ob = new IntersectionObserver(
          (changes) => {
            // changes 是个数组包含所有的监听对象和视口的交叉位置
            changes.forEach((item) => {
              if (item.isIntersecting) {
                //  item.isIntersecting == 1 为 true
                //  当先监听的对象 符合条件
                let lazyImg = item.target; // 拿到当前监听的盒子
                // 改变src
                el.src = bing.value;
                // 加载完移除监听
                ob.unobserve(lazyImg);
              }
            });
          },
          {
            // threshold 控制交叉状态在什么养的情况下触发上面的回调
            threshold: [1], // 0 一露头 0.5 露一半 1 完全出现
          }
        );
        // 使`IntersectionObserver`开始监听一个目标元素。
        ob.observe(el);
      },
    },
  },
  //   beforeCreate(){
  //       // this.language = this.$i18n.locale
  //     console.log('localStorage.getItem-111-',this.$i18n.locale)
  //   }
  // ,
  created() {
    this.from = window.localStorage.getItem("from");
    switch (this.from) {
      case "login":
        this.initalMsg = this.initalMsg_login;
        this.initalMsg2 = this.initalMsg_login2;
        break;
      case "device":
        this.initalMsg = this.initalMsg_devicePage;
        this.initalMsg2 = this.initalMsg_devicePage2;
        break;
      case "me":
        this.initalMsg = this.initalMsg_mePage;
        this.initalMsg2 = this.initalMsg_mePage2;
        break;
      case "scale":
        this.initalMsg = this.initalMsg_balancePage;
        this.initalMsg2 = this.initalMsg_balancePage2;
        break;
      case "tape":
        this.initalMsg = this.initalMsg_tapPage;
        this.initalMsg2 = this.initalMsg_tapPage2;
        break;
      default:
        this.initalMsg = this.initalMsg_home;
        this.initalMsg2 = this.initalMsg_home2;
        break;
    }
    // if (this.from === "home") {
    //   this.initalMsg = this.initalMsg_login;
    //   console.log('initalMsg---', this.initalMsg)
    // } else {
    //   this.initalMsg = this.initalMsg_home;
    // }
    console.log("Vue----", this.form);
  },

  mounted() {
    //       if (!that.lightbox) {
    //   that.lightbox = new PhotoSwipeLightbox({
    //     gallery: '#pic',
    //     children: 'a',
    //     pswpModule: () => import('photoswipe'),
    //   });
    //   that.lightbox.init();
    // }
    // if (window.webkit != undefined) {
    //   window.webkit.messageHandlers.hideLoading.postMessage(null);
    // } else {
    //   feedback.hideLoading();
    // }

    // // window.webkit.messageHandlers.hideLoading.postMessage(null);

    // this.$nextTick(() => {
    //   console.log("333");
    //   // 仅在整个视图都被渲染之后才会运行的代码
    //   if (window.webkit != undefined && this.$route.query.flag == 1) {
    //     window.webkit.messageHandlers.hideLoading.postMessage(null);
    //   } else if (this.$route.query.flag == 1) {
    //     feedback.hideLoading();
    //   }
    // });
    let u = navigator.userAgent;
    this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    window.onKeyUpBack = this.onKeyUpBack;
    window.saveImageResult = this.saveImageResult;
    // var viewer;
    this.language = this.$i18n.locale;
    console.log("localStorage.getItem-33-", this.$i18n.locale);
    // window.addEventListener("touchmove",viewer.hide());
    window.addEventListener("online", this.update, false), // 网络由异常到正常时触发
      window.addEventListener("offline", this.update, false); //网络由正常到异常时触发

    const element = document.querySelectorAll("#pic");

    for (let i = 0; i < element.length; i++) {
      const pictures = element[i].querySelectorAll("img");
      //   viewer = new Viewer(element[i], {
      //     navbar: false,

      //     title: function () {
      //       // const viewdiv = '上传人: ' + _that.updateUserName + '上传时间: ' + _that.updateTime;
      //       // const count = element[i].length;
      //       let that = this;
      //       that.pictureUrl = this.image.src;

      //       console.log("this.title--", that.pictureUrl);
      //       if (element[i].querySelectorAll("img").length === 1) {
      //        console.log('test--', this.options, this.title)
      //       // document.getElementsByClassName('viewer-footer')[0].style.display = 'none';
      //       //  this.options.title = false
      //       //  title =  false;
      //        this.title.style.display = 'none'
      //       } else {
      //          return (
      //         this.index + 1 + "/" + element[i].querySelectorAll("img").length
      //       );
      //       }

      //     },
      //     toolbar: {
      //       // oneToOne: true,
      //       // prev: function () {
      //       //   viewer.prev(true);
      //       // },

      //       // play: true,

      //       // next: function () {
      //       //   viewer.next(true);
      //       // },

      //       download: function () {
      //         // imageToBase64(element[i].getElementsByTagName('img')[0].src)
      //         // this.pictureUrl = this.image.src;
      //         console.log(
      //           "imagedownload---",
      //           document
      //             .getElementsByClassName("viewer-canvas")[0]
      //             .getElementsByTagName("img")[0].src
      //         );

      //         this.pictureUrl = document
      //           .getElementsByClassName("viewer-canvas")[0]
      //           .getElementsByTagName("img")[0].src;
      //         // let that = this;

      //         if (window.webkit != undefined) {
      //           // console.log("pictureBg---", this.pictureUrl);
      //           window.webkit.messageHandlers.saveImage.postMessage(
      //             this.pictureUrl
      //           );
      //           // window.localStorage.clear();
      //           // window.webkit.messageHandlers.back.postMessage(null);
      //         } else {
      //           console.log("pictureBg---", this.pictureUrl);
      //           // let imgUrl =
      //           feedback.saveImage(this.pictureUrl);
      //         }
      //         console.log(
      //           "mounted---",
      //           element[i],
      //           element[i].getElementsByTagName("img")[i].src
      //         );
      //         // const a = document.createElement('a');

      //         // a.href = viewer.image.src;
      //         // a.download = viewer.image.alt;
      //         // document.body.appendChild(a);
      //         // a.click();
      //         // document.body.removeChild(a);
      //         // console.log("mounted---", element[i], element[i].getElementsByTagName('img')[0].src);
      //       },
      //     },
      //     toggleOnDblclick: false,
      //     button: true,
      //    // transition: false,
      //     // tooltip: false,
      //     show: function () {
      //       console.log("imageshow2222---", this.canvas);

      //       // console.log("imageshow---", viewer.image);
      //       // $(viewer.canvas).on('touchend.viewerjs touchcancel.viewerjs mouseup.viewerjs pointerup.viewerjs', function(event){
      //       // 					if(event.target.tagName !== 'IMG') {
      //       // 						viewer.hide();
      //       // 					}
      //       // 				});
      //       $(document).on(
      //         "touchend.viewerjs touchcancel.viewerjs mouseup.viewerjs pointerup.viewerjs",
      //         function (event) {
      //           detectBounds();
      //         }
      //       );
      //     },
      //     view: function (e) {
      //       let that = this;
      //       let i;
      //       const height  = window.localStorage.getItem('status_height');
      //       const test = document.getElementsByClassName('viewer-canvas');
      //       const closeBtn = document.getElementsByClassName('viewer-button viewer-close');
      //       const downloadBtn = document.getElementsByClassName('viewer-download');
      //        for (i = 0; i < test.length; i++) {
      //     test[i].style.top = 50% - height + 'px'
      // }
      //      for (i = 0; i < closeBtn.length; i++) {
      //     closeBtn[i].style.top = 50% - height + 'px'
      // }
      //    for (i = 0; i < downloadBtn.length; i++) {
      //     downloadBtn[i].style.marginTop = 50% - height + 'px'
      // }

      //       //test.style.backgroundColor = 'red'
      //    test.style.top = 50% - height + 'px'
      //       // viewer.style.paddingTop = '4vw'
      //       console.log("imageshow---", test, test.style);
      //     },
      //     hide: function (e) {
      //       window.localStorage.removeItem("openPicture");
      //       // lockNativeBack.unLock();
      //       $(document).off(".viewerjs");
      //     },
      //     //   zoomed: function(e) {
      //     // 	detectBounds();
      //     // },
      //     // click: function(e) {
      //     //    console.log('click test--',e)
      //     // },

      //     // hide: function (e) {
      //     //   // viewer.destroy()
      //     //   // this.movable = false
      //     //   console.log("hide  test--", e.target);
      //     //   //隐藏自定义按钮
      //     // },
      //     // movable: false,
      //   });
      //   function detectBounds() {
      //     var switchRatio = 0.6;
      //     var $canvas = $(viewer.canvas);
      //     var imageData = viewer.imageData;
      //     var containerSize = viewer.containerData;
      //     var containerOffset = $canvas.offset();
      //     var compareRect = {
      //       width: imageData.width,
      //       height: imageData.height,
      //       left: imageData.left,
      //       top: imageData.top,
      //     };
      //     var isRotate = imageData.rotate == 90 || imageData.rotate == 270;
      //     var offsetX = imageData.left;
      //     var offsetY = imageData.top;
      //     var rotateOffset = 0; // 旋转后，宽高改变left、top需要增加的偏移
      //     var boundMargin = 10;

      //     if (isRotate) {
      //       rotateOffset = (imageData.width - imageData.height) / 2;

      //       var tmp = compareRect.width;
      //       compareRect.width = compareRect.height;
      //       compareRect.height = tmp;
      //       compareRect.left += rotateOffset;
      //       compareRect.top -= rotateOffset;
      //     }

      //     // 停靠
      //     if (compareRect.width <= containerSize.width) {
      //       // dock to center
      //       offsetX =
      //         (containerSize.width - compareRect.width) / 2 +
      //         containerOffset.left -
      //         rotateOffset;
      //     } else if (compareRect.left > containerOffset.left) {
      //       // dock to left
      //       offsetX = boundMargin - rotateOffset;
      //     } else if (
      //       compareRect.left + compareRect.width <
      //       containerOffset.left + containerSize.width
      //     ) {
      //       // dock to right
      //       offsetX =
      //         containerOffset.left +
      //         containerSize.width -
      //         compareRect.width -
      //         boundMargin -
      //         rotateOffset;
      //     }

      //     if (compareRect.height <= containerSize.height) {
      //       let u = navigator.userAgent;

      //       // viewer.hide()
      //       console.log('this.isOS',  !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), viewer.action, viewer.target)
      //       if (!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
      //         // dock to center
      //         offsetY =
      //           (containerSize.height - compareRect.height) / 3 +
      //           containerOffset.top +
      //           rotateOffset;
      //       } else {
      //         offsetY =
      //           (containerSize.height - compareRect.height) / 2 +
      //           containerOffset.top +
      //           rotateOffset;
      //       }
      //     } else if (compareRect.top > containerOffset.top) {
      //       // dock to top
      //       offsetY = boundMargin + rotateOffset;
      //     } else if (
      //       compareRect.top + compareRect.height <
      //       containerOffset.top + containerSize.height
      //     ) {
      //       // dock to bottom
      //       offsetY =
      //         containerOffset.top +
      //         containerSize.height -
      //         compareRect.height -
      //         boundMargin +
      //         rotateOffset;
      //     }

      //     viewer.moveTo(offsetX, offsetY);

      //     // 移动超过一定比例则切换图片
      //     if (compareRect.left > containerSize.width * switchRatio) {
      //       viewer.prev();
      //     } else if (
      //       compareRect.left + compareRect.width <
      //       containerSize.width * (1 - switchRatio)
      //     ) {
      //       viewer.next();
      //     }
      //   }
      let that = this;
      for (let i = 0; i < pictures.length; i++) {
        pictures[i].addEventListener("click", function (event) {
          // window.localStorage.setItem("openPicture", "true");

          // console.log("openPicture---", pictures[i].src);
          that.images[0].largeURL = pictures[i].src;
          that.images[0].thumbnailURL = pictures[i].src;

          console.log("openPicture---", pictures[i].src, that.images);

          if (window.webkit != undefined) {
            window.webkit.messageHandlers.isHiddenNav.postMessage(true);
          }
        });
      }

      console.log("mounted---", element[i], pictures);
    }

    const that = this;
    that.htest = window.innerHeight + "px"; // 屏幕高度
  },

  beforeDestroy() {
    window.removeEventListener("online", this.update, false);
    window.removeEventListener("offline", this.update, false);
    window.removeEventListener("click");
  },
  methods: {
    // 记录初始滑动位置
    onTouchStart(e) {
      e = e || event;
      // e.preventDefault();
      if (e.touches.length == 1) {
        this.startX = e.touches[0].clientX;
      }
    },
    // 记录每次滑动位置
    onTouchMove(e) {
      e = e || event;
      // e.preventDefault();
      let surrentStartX;
      if (e.touches.length == 1) {
        surrentStartX = e.touches[0].clientX;
      }
      console.log("surrentStartX--", surrentStartX, this.startX, this.current);
      if (surrentStartX < this.startX) {
        // 右滑
        if (this.current === 0) {
          this.touchable = true;
        } else {
          this.touchable = false;
        }

        // this.$refs.vantSwiper.resize();
      } else {
        // 左滑
        if (this.current === 1) {
          this.touchable = true;
        } else {
          this.touchable = false;
        }
        // this.$refs.vantSwiper.resize();
      }
    },
    onTouchEnd(position) {},
    checkActive(index) {
      console.log("current--", index, this.current);
      return index === this.current; // current为监听的轮播index
    },
    handleClose() {
      this.imagesTest = [];
      this.showPic = false;
    },
    onChange(newIndex) {
      this.current = newIndex;
      // if(newIndex === 1) {
      //   document.getElementById("item0").style.width = '60vw'
      // } else {

      //   document.getElementById("item0").style.width = '91vw'
      // }
      console.log("newIndex---", newIndex, this.clientWidth);
    },
    login() {
      let AmazonCognitoIdentity = require("amazon-cognito-identity-js");
      // var cognitoUser = userPool.getCurrentUser();

      let authenticationData = {
        Username: "lexuser",
        Password: "gPKs2eT#6zn",
      };
      let authenticationDetails =
        new AmazonCognitoIdentity.AuthenticationDetails(authenticationData);
      let poolData = {
        UserPoolId: "us-east-1_f4Aymseho", // Your user pool id here
        ClientId: "3iu9re39amkm67ma6svoj7q4vd", // Your client id here
      };
      let userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);

      let userData = {
        Username: "lexuser",
        Pool: userPool,
      };
      let cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: function (result) {
          let accessToken = result.getAccessToken().getJwtToken();
          console.log("onSuccess---", accessToken);
          //POTENTIAL: Region needs to be set if not already set previously elsewhere.
          AWS.config.region = "us-east-1";

          AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: "us-east-1:2fca637a-e90c-443e-b34c-a5cec2ffca30", // your identity pool id here
            Logins: {
              // Change the key below according to the specific region your user pool is in.
              "cognito-idp.us-east-1.amazonaws.com/us-east-1_f4Aymseho": result
                .getIdToken()
                .getJwtToken(),
            },
          });

          //refreshes credentials using AWS.CognitoIdentity.getCredentialsForIdentity()
          AWS.config.credentials.refresh((error) => {
            if (error) {
              console.error("11---", error);
            } else {
              // Instantiate aws sdk service objects now that the credentials have been updated.
              // example: var s3 = new AWS.S3();
              console.log("Successfully logged!");
            }
          });
        },

        onFailure: function (err) {
          alert(err.message || JSON.stringify(err));
        },
      });
    },
    saveImageResult(param) {
      console.log("saveImageResult param---", param);
      if (window.webkit != undefined) {
        let text = this.$t("licence.savetoAlbum");
        window.webkit.messageHandlers.showToast.postMessage(text);
      } else {
        let text = this.$t("licence.savetoAlbum");
        feedback.showToast(text);
      }
    },
    onKeyUpBack(param) {
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      // const result = JSON.parse(param);
      if (isiOS) {
        // this.sendHelp();

        console.log("onKeyUpBack ios---");
        let content = this.$store.state.messages;
        let content1 = content.slice(-30);
        console.log(
          "this.$store.state.messages---",
          content[this.$store.state.messages.length - 1].id,
          content1,
          content.length
        );

        if (content[this.$store.state.messages.length - 1].id != 0) {
          let that = this;
          // console.log('查找current---',  value, value1, typeof(value1))
          axios
            .post(
                "https://cloud.renpho.com/RenphoHealth/robot/save",
              // "http://renpho.net:7009/RenphoHealth/robot/save",
              {
                content: content1,
                timeStamp: new Date().getTime(),
                timeZone: window.localStorage.getItem("timeZone"),
              },
              {
                headers: {
                  token:
                    // "eyJUeXBlIjoiSnd0IiwidHlwIjoiSldUIiwiYWxnIjoiSFMyNTYifQ.eyJleHAiOjE2NjcwMjYwODcsImlhdCI6MTY2NDQzNDA4NywidXNlcklkIjoyNDcyMTQyOTU5MDQ3Mzg3OTA4fQ.lHznijryQmuYM-blVD9bYfKjgYjXBx2-LoVK5Zp7ph8",

                    window.localStorage.getItem("token"),
                },
              }
            )
            .then(function (response) {
              // that.devices = response.data;
              console.log(response);
              console.log("添加成功---", response);
            })
            .catch(function (error) {
              console.log("err", error);
            });
        }
        window.webkit.messageHandlers.back.postMessage(null);

        // this.queryParams = result.userInfo.token;
        // this.$emit('sendToken',this.queryParams)
        // window.localStorage.setItem("lang", result.userInfo.language);
      } else {
        feedback.back();
      }
    },
    // newHandle(res) {
    //   // this.update(res);

    // },
    update(res) {
      console.log(res);
      this.onLine = res.type === "online";
      if (this.onLine) {
        console.log("网络正常---", this.$route.query.token);
      } else if (this.$route.query.token !== "null") {
        console.log("网络异常---", this.$route.query.token);
      }
    },
    getUrlParam() {
      var name, value;
      var str = location.href; //取得整个地址栏
      var num = str.indexOf("?");
      str = str.substr(num + 1); //取得所有参数   stringvar.substr(start [, length ]

      var arr = str.split("&"); //各个参数放到数组里
      for (var i = 0; i < arr.length; i++) {
        num = arr[i].indexOf("=");
        if (num > 0) {
          name = arr[i].substring(0, num);
          value = arr[i].substr(num + 1);
          this[name] = value;
        }
      }
      console.log("getUrlParam----", str);
    },

    //防抖
    debounce(fn, delay) {
      return (function (...args) {
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          fn.call(this, args);
        }, delay);
      })();
    },
    pushFeedback() {
      // console.log('pushFeedback22---')
      if (window.webkit != undefined) {
        window.webkit.messageHandlers.feedback.postMessage({
          title: "测试分享的标题",
          content: "测试分享的内容",
          url: "https://github.com/maying1992",
        });
      } else {
        //       try {
        //   result = feedback.getUserInfo();
        //   console.log('result---',result)
        // } catch(err){
        //   console.log('err---',err)
        // }
        feedback.postMessage();
      }
      /* eslint-disable */
    },
    changeFoldState() {
      this.brandFold = !this.brandFold;
      // altHtmlMessage()
    },

    Faq(item, index) {
      console.log("Faq----", item, index);

      if (this.onLine === false) {
        // toast({ text: this.$t("licence.key_internet_error"), time: 1000 });
        if (window.webkit != undefined) {
          let text = this.$t("licence.key_internet_error");
          window.webkit.messageHandlers.showToast.postMessage(text);
        } else {
          let text = this.$t("licence.key_internet_error");
          feedback.showToast(text);
        }
      } else {
        console.log("Faq----", item, index);
        this.dynamic = index;
        let val = item;
        console.log("Faq----", item, index);
        const message = {
          type: "human",
          text: val,
        };
        this.$store.dispatch("postTextMessage", message);
        console.log("事件---", val);
        // return val;
      }
    },
    encodeAsHtml(value) {
      return value
        .replace(/&/g, "&amp;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
    },
    botMessageWithLinks(messageText) {
      console.log(
        "botMessageWithLinks---",
        this.message,
        this.message.text,
        this.message.text === "Sorry" ||
          this.message.text === "Aww" ||
          this.message.text === "啊哇" ||
          this.message.text === "ああ" ||
          this.message.text === "噢"
      );
      //  console.log('messageText---',messageText,typeof(messageText),messageText.length)
      if (this.brandFold && messageText.length > 100) {
        messageText = messageText.slice(0, 110);
      }
      const linkReplacers = [
        // The regex in the objects of linkReplacers should return a single
        // reference (from parenthesis) with the whole address
        // The replace function takes a matched url and returns the
        // hyperlink that will be replaced in the message
        {
          type: "web",
          regex: new RegExp(
            "\\b((?:https?://\\w{1}|www\\.)(?:[\\w-.]){2,256}" +
              "(?:[\\w._~:/?#@!$&()*+,;=['\\]-]){0,256})",
            "im"
          ),
          replace: (item) => {
            const url = !/^https?:\/\//.test(item) ? `http://${item}` : item;
            return (
              '<a target="_blank" ' +
              `href="${encodeURI(url)}">${this.encodeAsHtml(item)}</a>`
            );
          },
        },
      ];
      // TODO avoid double HTML encoding when there's more than 1 linkReplacer
      return linkReplacers.reduce(
        (message, replacer) =>
          // splits the message into an array containing content chunks
          // and links. Content chunks will be the even indexed items in the
          // array (or empty string when applicable).
          // Links (if any) will be the odd members of the array since the
          // regex keeps references.
          message
            .split(replacer.regex)
            .reduce((messageAccum, item, index, array) => {
              let messageResult = "";
              if (index % 2 === 0) {
                const urlItem =
                  index + 1 === array.length
                    ? ""
                    : replacer.replace(array[index + 1]);
                messageResult = `${this.encodeAsHtml(item)}${urlItem}`;
              }
              return messageAccum + messageResult;
            }, ""),
        messageText
      );
    },
    // used for stripping SSML (and other) tags from bot responses
    stripTagsFromMessage(messageText) {
      console.log("stripTagsFromMessage---", this.message);
      const doc = document.implementation.createHTMLDocument("").body;
      doc.innerHTML = messageText;
      return doc.textContent || doc.innerText || "";
    },

    prependBotScreenReader(messageText) {
      // let messageTexts = messageText.replace(/<[^>]+>/g, '');
      console.log("prependBotScreenReader--", messageText);

      return `<span class="sr-only" id="bot">bot says: </span>${messageText}`;
    },
  },
};
</script>

<style scoped>
@font-face {
  font-family: "Poppins-SemiBold";
  font-display: swap;
  src: url("../assets/fonts/Poppins-SemiBold.ttf");
}
.message-text {
  hyphens: auto;
  overflow-wrap: break-word;
  padding: 1.5em;
  white-space: normal;
  word-break: break-word;
  width: 100%;
  color: #333333;
}

.text {
  display: wrap;
  margin-bottom: 1em;
}
.initalMsgbtn {
  display: block;
  margin-left: 2vw;
  border-radius: 15pt;
  /* font-size: 1.5rem; */
  color: #fff;
  /* padding: 10pt; */
  /* margin: 2pt; */
}
.buton {
  outline: 0;
  color: #0a79c3;
  font-weight: 600;
  border: none !important;
  border-radius: 15pt;
  font-size: 1rem;
  padding: 10pt;
  margin: 2pt;
  background-color: rgba(10, 121, 195, 0.1);
}
</style>

<style>
.viewer-toolbar {
  top: 0 !important;
  position: fixed;
  right: 10px;
}

.sr-only {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(1px, 1px, 1px, 1px) !important;
  clip-path: inset(50%) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.viewer-download {
  content: url("../assets/download@2x.png");
  background-color: none !important;
  color: #fff;
  font-family: FontAwesome, serif;
  font-size: 0.75rem;
  line-height: 1.5rem;
  text-align: center;
  -webkit-touch-callout: none;

  /* top: 10px; */
  /* margin-left: 10; */
  /* position: fixed; */
  /* right: 10px; */
}
.viewer-button {
  content: url("../assets/close@2x.png");
  -webkit-touch-callout: none;
}
/* .viewer-download::before {
  background-image: url('../assets/happyface-light@2x.png');
  content: url('../assets/happyface-light@2x.png');
} */
/* .viewer-download::before {
  background-position: -120px 0;
  content: "Download";
} */

/*按钮主要样式*/
.viewer-btn {
  bottom: 0;
  left: 0;
  overflow: hidden;
  position: absolute;
  right: 0;
  text-align: center;
  z-index: 10000;
}

.viewer-btn a {
  background-color: #1e9fff;
  border: none;
  color: white;
  padding: 18px 12px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
}

.viewer-btn a i {
  font-size: 20px;
}

.my-swipe2 {
  width: 95vw !important
}

.my-swipe3 {
  /* color: #fff; */
  /* font-size: 20px; */
  width: 85vw !important;
  height: 50vw !important;
  padding-bottom: 8vw;
  padding-top: 2vw;
  margin-left: -6vw !important;
  /* padding-right: 3vw; */
  /* line-height: 150px; */
  /* text-align: center; */
  /* background-color: #39a9ed;
     */
  background: -webkit-linear-gradient(left, #0a79c3, #3ea9d7);
  border-radius: 3vw;
}

.my-swipe4 {
  /* color: #fff; */
  /* font-size: 20px; */
  width: 85vw !important;
  height: 50vw !important;
  padding-bottom: 8vw;
  padding-top: 2vw;


  /* margin-right: 3vw !important; */
  /* line-height: 150px; */
  /* text-align: center; */
  /* background-color: #39a9ed;
     */
  background: -webkit-linear-gradient(left, #0a79c3, #3ea9d7);
  border-radius: 3vw;
}
.custom-indicator {
  /* position: absolute; */
  /* right: 5px; */
  /* bottom: 5px; */
  /* padding: 2px 5px; */
  /* font-size: 12px; */
  /* background: rgba(0, 0, 0, 0.1); */
  width: 12px;
  height: 12px;
  background: #ffffff;
  opacity: 0.5;
  border-radius: 6px;
  opacity: 0.4;
  bottom: 5vw;
  position: relative;
}

.my-swipe .van-swipe-item {
  color: #fff;
  /* font-size: 20px; */
  /* line-height: 150px; */
  text-align: center;
  background-color: green;
}

.indicators {
  position: initial;
  left: 50%;
  margin-right: 188vw;
  display: flex;
  transform: translateX(-50%);
}

.indicatorli {
  width: 6px;
  height: 6px;
  background: #ffffff;
  border-radius: 6px;
  opacity: 0.4;
  display: inline;
  top: -5.6vw;
  right: -5vw;
  position: absolute;
}

.indicator li:not(:last-child) {
  margin-right: 6px;
}

.indicator li .active {
  background-color: white;
  opacity: 1;
}

/* .indicatorli2 {
  display: inline;
  width: 12px;
  height: 3px;
  background-color: white;
  border-radius: 30%;
  opacity: 0.3;
  transition: opacity 0.5s, background-color 0.5s;
  top: -5vw;
  right: 2vw;
  position: absolute;
  opacity: inherit;
} */

.indicatorli2 {
  /* display: inline; */
  width: 6px;
  height: 6px;
  background: white;

  border-radius: 6px;
  /* opacity: 0.4; */
  opacity: inherit;
  display: inline;
  top: -5.6vw;
  right: 0vw;
  position: absolute;
}

/* .indicatorli3 {
  display: inline;
  width: 12px;
  height: 3px;
  background-color: white;
  border-radius: 30%;
  opacity: 0.3;
  transition: opacity 0.5s, background-color 0.5s;
  top: -5vw;
  right: -6vw;
  position: absolute;
  opacity: inherit;
} */

.indicatorli3 {
  width: 6px;
  height: 6px;
  background: #ffffff;
  border-radius: 6px;
  opacity: inherit;
  display: inline;
  top: -5.6vw;
  right: -7vw;
  position: absolute;
}

.indicatorli4 {
  width: 6px;
  height: 6px;
  background: #ffffff;
  border-radius: 6px;
  opacity: 0.4;
  display: inline;
  top: -5.6vw;
  right: -2vw;
  position: absolute;
}

.question {
  color: #fff;
  font-size: 4vw;
  display: flex;
  justify-content: space-between;
  width: 75vw;
  margin-left: -2.0vw;
  padding-left: 1vw;
  /* margin-bottom: 4vw; */
  margin-top: 1vw;
    opacity: 0.7;
    overflow: visible;
}

.question:active {
  opacity: 0.2;

}

/deep/.van-swipe__track {
  /* display: flex;
    z-index: 99999; */
}
/* .viewer-download::before {
  content: "download";
  color: transparent;
  display: block;
  font-size: 0;
  height: 20px;
  line-height: 0;
  width: 20px;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAXBJREFUOE/VlDFLlmEUhq9ra3HoT0RDCOIQEQnVkJRQU4QQJEKBICKmNFWEODRHUxJEaDT1ExxUJFLQpSEcxJ+gIE13PPa9H6+f72cSLr7j85xz3ec+57yPnPHnGfM4x8Ak88AD4ADYVO+dpj2NlpP8AH4CM0APMAX0A88rqLrUJHAMmGQWuK7erCckmQOutc76gA9qW6At1KmS5COwrr47yWKStIRX63FHKkxSlN8CL9T1fwAnChCYVbeOVZjkPvAZWFCfddi9AYyrDzvOR4t1YFktMX/3MMkVYBF40lRZkkZgBU/yFdhRpyvgBvBG/dZkswV8rD7tcj8EjKl3K+AucEv91SVhABhRR7rcvwQuqpMVcBIYVO909OgL8B0oQo+AfeBSfaWS9JbFB4bVxfaUk6wAe8Ca+rrWn/fAVWD7sOm1wST5BNwGXqllOEcfhySlist1YGtoJfFCw5THgHn1d9fFPs3/elLMOX6+/tf6HzsPjRVd/9/RAAAAAElFTkSuQmCC);
} */
</style>

